module.exports = __webpack_public_path__ + "img/ms.c5827985.svg";